import { Navigate } from 'react-router-dom';

function HomePage() {
  return <Navigate to="/templates" replace />;
}

export default HomePage;
